/* ============================================================
   WHATSAPP + COLLECTION PAGE CRO JS
   (Email popup removed)
   ============================================================ */

(function () {
  'use strict';

  // ── 1. WHATSAPP FLOATING BUTTON ──
  function buildWhatsApp() {
    if (document.querySelector('.cro-wa-btn')) return;
    var btn = document.createElement('a');
    btn.className = 'cro-wa-btn';
    btn.href = 'https://wa.me/+923278798204';
    btn.target = '_blank';
    btn.rel = 'noopener';
    btn.setAttribute('aria-label', 'Chat on WhatsApp');
    btn.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>';
    document.body.appendChild(btn);
  }

  // ── 2. COLLECTION PAGE UPGRADES ──
  function initCollectionPage() {
    var isCollection = window.location.pathname.includes('/collections/');
    if (!isCollection) return;
    var main = document.querySelector('#MainContent, main');
    if (!main) return;
    var firstSection = main.firstElementChild;
    if (!firstSection) return;
    var colName = document.querySelector('.collection__title h1, .collection h1, h1');
    var colNameText = colName ? colName.textContent.trim() : 'Our Collection';
    var hero = document.createElement('div');
    hero.className = 'cro-collection-hero';
    hero.innerHTML = '<h1>' + colNameText + '</h1><p>Full-grain leather · COD available · Free returns in 30 days</p>';
    main.insertBefore(hero, firstSection);
    var grid = document.querySelector('.product-grid, ul.grid');
    if (grid) {
      var filters = [
        { label: 'All', type: '' },
        { label: 'Pure Leather', type: 'pure' },
        { label: 'PU Leather', type: 'pu' },
        { label: 'Wallets', type: 'wallet' },
        { label: 'Bags', type: 'bag' },
        { label: 'Gifts', type: 'gift' },
      ];
      var filterBar = document.createElement('div');
      filterBar.className = 'cro-filter-bar page-width';
      filters.forEach(function(f, i) {
        var pill = document.createElement('button');
        pill.className = 'cro-filter-pill' + (i === 0 ? ' is-active' : '');
        pill.textContent = f.label;
        pill.dataset.type = f.type;
        pill.addEventListener('click', function() {
          filterBar.querySelectorAll('.cro-filter-pill').forEach(function(p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          var cards = document.querySelectorAll('.product-card-wrapper, li.grid__item');
          cards.forEach(function(card) {
            if (!f.type) { card.style.display = ''; return; }
            var title = (card.querySelector('.card__heading, h3') || {}).textContent || '';
            var titleL = title.toLowerCase();
            var show = false;
            if (f.type === 'pure') show = titleL.includes('pure');
            else if (f.type === 'pu') show = titleL.includes('pu ') || titleL.startsWith('pu');
            else if (f.type === 'wallet') show = titleL.includes('wallet') || titleL.includes('card holder') || titleL.includes('slimfold');
            else if (f.type === 'bag') show = titleL.includes('bag') || titleL.includes('backpack') || titleL.includes('vault') || titleL.includes('vanguard') || titleL.includes('axis');
            else if (f.type === 'gift') show = titleL.includes('box') || titleL.includes('kit') || titleL.includes('parfum') || titleL.includes('keychain');
            card.style.display = show ? '' : 'none';
          });
        });
        filterBar.appendChild(pill);
      });
      var count = document.querySelectorAll('.product-card-wrapper, li.grid__item').length;
      var countEl = document.createElement('div');
      countEl.className = 'cro-product-count page-width';
      countEl.textContent = count + ' products';
      grid.parentElement.insertBefore(filterBar, grid);
      grid.parentElement.insertBefore(countEl, grid);
    }
  }

  function init() {
    buildWhatsApp();
    initCollectionPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();
